"use client";

import { useState } from "react";
import Link from "next/link";
import { ArrowRight, LoaderCircle } from "lucide-react";
import { authClient } from "@/lib/auth-client";
import { recordSessionActivity } from "@/lib/session-activity";

export function LoginButton({
  configured,
  demo,
}: {
  configured: boolean;
  demo: boolean;
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (demo) {
    return (
      <Link className="login-primary-button" href="/dashboard">
        Open dashboard preview
        <ArrowRight size={17} aria-hidden="true" />
      </Link>
    );
  }

  async function signIn() {
    setLoading(true);
    setError(null);
    recordSessionActivity();
    try {
      const result = await authClient.signIn.social({
        provider: "google",
        callbackURL: "/dashboard",
        errorCallbackURL: "/login?error=oauth",
      });
      if (result.error) {
        setError(result.error.message || "Google sign-in could not be started.");
        setLoading(false);
      }
    } catch {
      setError("Google sign-in could not be started. Please try again.");
      setLoading(false);
    }
  }

  return (
    <>
      <button
        className="google-login-button"
        type="button"
        onClick={signIn}
        disabled={!configured || loading}
      >
        <span className="google-mark" aria-hidden="true">
          G
        </span>
        <span>{loading ? "Opening Google…" : "Continue with Google Workspace"}</span>
        {loading ? (
          <LoaderCircle className="spin" size={18} aria-hidden="true" />
        ) : (
          <ArrowRight size={18} aria-hidden="true" />
        )}
      </button>
      {!configured && (
        <p className="login-config-note">
          Sign-in is locked until the Google and database environment values are
          configured.
        </p>
      )}
      {error && <p className="form-error">{error}</p>}
    </>
  );
}
